/**
 * ppf-locations.js — Leaflet/OSM map for the PPF Locations section.
 * Coordinates are baked into the section's block settings at build time;
 * this file never geocodes at runtime. Loads Leaflet from cdnjs exactly
 * once no matter how many .ppf-locations sections exist on the page.
 */
(function () {
  var LEAFLET_CSS = 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.css';
  var LEAFLET_JS = 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.js';
  var TILE_URL = 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png';
  var TILE_ATTRIBUTION =
    '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a> contributors ' +
    '&copy; <a href="https://carto.com/attributions" target="_blank" rel="noopener">CARTO</a>';

  var mapsById = {};

  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  function gmapsUrl(name, address) {
    return (
      'https://www.google.com/maps/search/?api=1&query=' +
      encodeURIComponent(name + ', ' + address)
    );
  }

  function loadLeaflet(callback) {
    if (window.L) {
      callback();
      return;
    }
    if (window.__ppfLeafletCallbacks) {
      window.__ppfLeafletCallbacks.push(callback);
      return;
    }
    window.__ppfLeafletCallbacks = [callback];

    if (!document.querySelector('link[data-ppf-leaflet-css]')) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = LEAFLET_CSS;
      link.setAttribute('data-ppf-leaflet-css', '');
      document.head.appendChild(link);
    }

    var script = document.createElement('script');
    script.src = LEAFLET_JS;
    script.setAttribute('data-ppf-leaflet-js', '');
    script.onload = function () {
      var callbacks = window.__ppfLeafletCallbacks || [];
      window.__ppfLeafletCallbacks = null;
      callbacks.forEach(function (cb) {
        cb();
      });
    };
    document.head.appendChild(script);
  }

  function pinIcon() {
    return window.L.divIcon({
      className: 'ppf-locations__pin-wrap',
      html: '<span class="ppf-locations__pin"></span>',
      iconSize: [26, 36],
      iconAnchor: [13, 36],
      popupAnchor: [0, -32],
    });
  }

  function initMap(section) {
    var mapEl = section.querySelector('[data-ppf-locations-map]');
    var dataEl = section.querySelector('[data-ppf-locations-data]');
    if (!mapEl || !dataEl) return;

    var stores;
    try {
      stores = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    stores = stores.filter(function (s) {
      return s.lat && s.lng && !isNaN(parseFloat(s.lat)) && !isNaN(parseFloat(s.lng));
    });
    if (!stores.length) return;

    // Theme editor re-renders section markup on setting changes; tear down
    // any previous map instance bound to this container before rebuilding.
    var existing = mapsById[mapEl.id];
    if (existing) {
      existing.remove();
      delete mapsById[mapEl.id];
    }

    var L = window.L;
    var map = L.map(mapEl, { scrollWheelZoom: false });
    mapsById[mapEl.id] = map;

    L.tileLayer(TILE_URL, {
      attribution: TILE_ATTRIBUTION,
      maxZoom: 19,
    }).addTo(map);

    var icon = pinIcon();
    var markers = stores.map(function (store) {
      var lat = parseFloat(store.lat);
      var lng = parseFloat(store.lng);
      var marker = L.marker([lat, lng], {
        icon: icon,
        title: store.name + ' — ' + store.address,
      }).addTo(map);

      var popupHtml =
        '<div class="ppf-locations__popup">' +
        '<span class="ppf-locations__popup-name">' + escapeHtml(store.name) + '</span>' +
        '<span class="ppf-locations__popup-address">' + escapeHtml(store.address) + '</span>' +
        '<a class="ppf-locations__popup-link" href="' + gmapsUrl(store.name, store.address) + '" target="_blank" rel="noopener">Open in Google Maps →</a>' +
        '</div>';
      marker.bindPopup(popupHtml);
      return marker;
    });

    if (markers.length === 1) {
      map.setView(markers[0].getLatLng(), 13);
    } else {
      var bounds = L.latLngBounds(markers.map(function (m) { return m.getLatLng(); }));
      map.fitBounds(bounds, { padding: [30, 30], maxZoom: 12 });
    }

    // Theme editor mounts sections inside animated/hidden containers before
    // they're visible, so Leaflet's initial size read can be wrong.
    setTimeout(function () {
      map.invalidateSize();
    }, 250);

    var resizeHandler = function () {
      map.invalidateSize();
    };
    window.addEventListener('resize', resizeHandler);
  }

  function initAll() {
    var sections = document.querySelectorAll('[data-ppf-locations-section]');
    if (!sections.length) return;
    loadLeaflet(function () {
      sections.forEach(initMap);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify theme editor: re-init when this section is added or its
  // settings/blocks change and the section markup is replaced.
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector
      ? event.target.querySelector('[data-ppf-locations-section]')
      : null;
    if (!section && event.target.matches && event.target.matches('[data-ppf-locations-section]')) {
      section = event.target;
    }
    if (!section) return;
    loadLeaflet(function () {
      initMap(section);
    });
  });
})();
